import { JSONSchemaType } from 'ajv'

export interface ICustomConnectorFormData {
  connectorTypeId: string
  connectorName: string
  connectorJson: string
  inputParams: string
  outputParams: string
  isInactive: boolean
}

const CustomConnectorSchema: JSONSchemaType<ICustomConnectorFormData> = {
  type: 'object',
  properties: {
    connectorTypeId: {
      type: 'string',
      minLength: 1,
      errorMessage: 'Campo obrigatório',
    },
    connectorName: {
      type: 'string',
      minLength: 1,
      errorMessage: 'Campo obrigatório',
    },
    connectorJson: {
      type: 'string',
    },
    inputParams: {
      type: 'string',
    },
    outputParams: {
      type: 'string',
    },
    isInactive: {
      type: 'boolean',
      default: false,
    },
  },
  required: ['connectorTypeId', 'connectorName'],
  additionalProperties: false,
}

export default CustomConnectorSchema
